export default __webpack_public_path__ + "static/media/Deceiver's Pants of Ushering Twilight.6ad693c2.jpg";